// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"59d87675","533":"45bd1423"}[chunkId] + ".chunk.js";
};